function AppMobile() {
  const mobileParameter = 'mobileAppView';
  const searchParameters = (typeof window !== 'undefined' && window.location.search) || '';

  return searchParameters.indexOf(mobileParameter) !== -1;
}

export const isAppMobile = AppMobile();
